module.exports = __webpack_public_path__ + "static/media/onboarding-location.1b6399a7.png";